export const REPLY_MEDIA_FEATURE = 'reply_media'

export function replyMediaEnabled(): boolean {
    return true
}
